<template lang="pug">
.v-confirm-modal.confirm-modal(v-if="data" )
	.confirm-modal__title(v-if="data.title" ) {{ data.title }}
	.confirm-modal__note(v-if="data.note" ) {{ data.note }}
	.confirm-modal__buttons
		button.confirm-modal__button(v-for="(button, index) in data.buttons"
			:key="index"
			:class="button.className"
			@click="handleEvent(button.event)")
			| {{ button?.text }}
</template>

<script>
import sourceMixin from '../components/mixins/v-mixin-source.vue';
import controller from '../scripts/controller/controller.js';
export default {
	mixins: [
		sourceMixin,
	],

	emits: ['confirm'],

	data() {
		return {
			data: null
		};
	},

	methods: {
		dataSet(data) {
			this.data = data;
		},

		handleEvent(event) {
			switch (event) {
				case 'reject': {
					controller.closeModal();
					break;
				}
				case 'confirm': {
					controller.closeModal();
					this.$emit('confirm');
					break;
				}
			}
		}
	}
};
</script>